import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Amplify from 'aws-amplify'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import './plugins/mq'
import './plugins/gtag'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false

// Cognito
Amplify.configure({
  Auth: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_8FK1Uo7Ku',
    userPoolWebClientId: '2fo8hqtg7b3e47negst8magujd'
  }
})

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
